// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__2lhEl","or":"button_select_or__1MsRG","wrapper":"button_select_wrapper__XmYv1","line":"button_select_line__2qGw7"};